import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";
import { Button } from "@/components/ui/button";

const COOKIE_KEY = "costalend_cookie_consent_v1";

function updateGoogleConsent(granted) {
  if (typeof window === "undefined") return;
  const gtag = window.gtag;
  if (typeof gtag !== "function") return;
  gtag("consent", "update", {
    ad_storage: granted ? "granted" : "denied",
    ad_user_data: granted ? "granted" : "denied",
    ad_personalization: granted ? "granted" : "denied",
    analytics_storage: granted ? "granted" : "denied",
    functionality_storage: "granted",
    personalization_storage: granted ? "granted" : "denied",
    security_storage: "granted",
  });
}

export default function CookieBanner() {
  const { t, buildPath } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(COOKIE_KEY);
      if (!stored) {
        setVisible(true);
      } else {
        const parsed = JSON.parse(stored);
        updateGoogleConsent(parsed.status === "accepted");
      }
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const persist = (status) => {
    try {
      localStorage.setItem(COOKIE_KEY, JSON.stringify({ status, ts: Date.now() }));
    } catch (e) {}
    updateGoogleConsent(status === "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label={t("cookie_banner.title")}
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-200 bg-white shadow-[0_-8px_30px_-15px_rgba(15,23,42,0.25)]"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-4 flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
        <div className="flex-1">
          <p className="text-sm font-semibold text-slate-900">{t("cookie_banner.title")}</p>
          <p className="text-sm text-slate-600 mt-1">
            {t("cookie_banner.description")}{" "}
            <Link
              to={buildPath("cookie-policy")}
              className="underline text-teal-700 hover:text-teal-800"
              data-testid="cookie-banner-policy-link"
            >
              {t("cookie_banner.policy_link")}
            </Link>
            .
          </p>
        </div>
        <div className="flex gap-2 shrink-0">
          <Button
            variant="outline"
            data-testid="cookie-reject-button"
            onClick={() => persist("rejected")}
            className="h-10 rounded-md px-4 text-sm border-slate-300 text-slate-700 hover:bg-slate-50"
          >
            {t("cookie_banner.reject")}
          </Button>
          <Button
            data-testid="cookie-accept-button"
            onClick={() => persist("accepted")}
            className="h-10 rounded-md px-4 text-sm bg-teal-600 hover:bg-teal-700 text-white"
          >
            {t("cookie_banner.accept_all")}
          </Button>
        </div>
      </div>
    </div>
  );
}
